import * as React from 'react'
import type { SVGProps } from 'react'
function SvgPvAnlagenPrivat253727075343(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 251.49 187.61"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="m144.8,187.61h-38.11c-1.38,0-2.5-1.12-2.5-2.5v-33.32c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v30.82h33.11v-30.82c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v33.32c0,1.38-1.12,2.5-2.5,2.5Z" />
      <path d="m167.32,187.61h-83.16c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5h83.16c1.38,0,2.5,1.12,2.5,2.5s-1.12,2.5-2.5,2.5Z" />
      <path d="m248.99,137.94H2.5c-.79,0-1.53-.37-2.01-1.01-.47-.63-.62-1.45-.39-2.21L40.01,1.78C40.33.72,41.3,0,42.4,0h166.68c1.1,0,2.08.72,2.39,1.78l39.9,132.94c.23.76.08,1.58-.39,2.21-.47.63-1.22,1.01-2.01,1.01Zm-243.13-5h239.77L207.23,5H44.26L5.86,132.94Z" />
      <path d="m84.67,137.94c-.08,0-.17,0-.25-.01-1.37-.14-2.38-1.36-2.24-2.74L95.48,2.25c.14-1.37,1.36-2.38,2.74-2.24,1.37.14,2.38,1.36,2.24,2.74l-13.3,132.94c-.13,1.29-1.22,2.25-2.48,2.25Z" />
      <path d="m166.82,137.94c-1.27,0-2.36-.96-2.48-2.25L151.04,2.75c-.14-1.37.86-2.6,2.24-2.74,1.38-.14,2.6.86,2.74,2.24l13.3,132.94c.14,1.37-.86,2.6-2.24,2.74-.08,0-.17.01-.25.01Z" />
      <path d="m227.74,71.47H23.75c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5h204c1.38,0,2.5,1.12,2.5,2.5s-1.12,2.5-2.5,2.5Z" />
    </svg>
  )
}
export default SvgPvAnlagenPrivat253727075343
